export default __webpack_public_path__ + "static/media/d2.80cb3446.png";